<button [type]="type" [disabled]="disabled || loading" [ngClass]="getClasses()" (click)="onClick($event)">
    <div class="flex items-center justify-center space-x-2">
        <lucide-icon *ngIf="loading" name="loader-2" class="animate-spin h-5 w-5"></lucide-icon>
        <lucide-icon *ngIf="icon && !loading" [name]="icon" class="h-5 w-5"></lucide-icon>
        <span *ngIf="hasContent"><ng-content></ng-content></span>
    </div>
</button>